import ConfigurationEdit from './ConfigurationEdit'

const routes = [{ path: '/dashboard/configuration/edit', component: ConfigurationEdit }]

export default routes
